import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pdf-container"
};
const _hoisted_2 = {
  class: "pdf-controls"
};
const _hoisted_3 = {
  key: 0,
  class: "content-box mt-4 relative overflow-hidden py-px"
};
const _hoisted_4 = {
  class: "title flex items-center justify-between px-3"
};
const _hoisted_5 = ["title"];
import html2pdf from 'html2pdf.js';
import { renderMarkdown } from '@/utils/markdown';
import { ref, onMounted, inject, watch, nextTick, toRaw } from 'vue';
import AnimateText from '../AnimateText.vue';
import ContentBlock from '../report-items/components/ContentBlock.vue';
import useMainStore from '../../main.store';
export default /*@__PURE__*/_defineComponent({
  __name: 'MonthlyReport',
  props: {
    item: {},
    content: {}
  },
  setup(__props) {
    const props = __props;
    const mainStore = useMainStore();
    const AnimateTextRef = ref();
    const info = ref({
      reportName: '',
      attachmentDetail: {
        fileContent: ''
      },
      tips: ''
    });
    const show = ref(true);
    const loading = ref(false);
    const hideBtn = ref(true);
    const contentRef = ref();
    const downloadPDF = async () => {
      try {
        loading.value = true;
        const ele = contentRef.value?.querySelector('.card-content');
        const opt = {
          margin: 20,
          filename: `${info.value.reportName}.pdf`,
          image: {
            type: 'jpeg',
            quality: 0.98
          },
          html2canvas: {
            scale: 1,
            useCORS: true,
            scrollY: 0,
            windowHeight: ele.scrollHeight,
            logging: false
          },
          jsPDF: {
            unit: 'px',
            format: [ele.clientWidth, ele.scrollHeight + 300],
            orientation: 'portrait',
            hotfixes: ['px_scaling'],
            compress: true // 启用压缩
          }
        };
        await html2pdf().set(opt).from(ele).save();
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
      }
    };
    const handleMdHtml = str => {
      if (str.indexOf('```html') > -1) {
        const html = str.replace(/^```html\s*([\s\S]*?)\s*```$/, '$1');
        return new DOMParser().parseFromString(html, 'text/html').body.innerHTML;
      }
      return renderMarkdown(str, 'flattened-report');
    };
    const openSideEdit = inject('openSideEdit');
    const handleEditView = () => {
      openSideEdit({
        type: 'view_report',
        typeQuery: {
          hideLeft: true,
          isMd: false
        },
        contentData: toRaw({
          content: handleMdHtml(info.value.attachmentDetail.fileContent)
        }),
        title: info.value.reportName,
        callBack: () => {
          setTimeout(() => {
            downloadPDF();
          }, 500);
        }
      });
    };
    function handleEnd() {
      show.value = true;
      loading.value = true;
      setTimeout(() => {
        loading.value = false;
        mainStore.loadNextMsg(props.item);
      }, 2000);
    }
    function handleAnimateEnd() {
      mainStore.loadNextMsg(props.item);
      hideBtn.value = false;
    }
    watch(() => props.item.openAnimate, async newVal => {
      if (newVal) {
        show.value = false;
        await nextTick();
        AnimateTextRef.value?.typeWriter(info.value.tips || '');
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      try {
        if (props.content) info.value = props.content;
        if (!props.item.openAnimate) {
          hideBtn.value = false;
        }
      } catch (error) {
        info.value = {
          tips: '',
          attachmentDetail: {
            fileContent: ''
          },
          reportName: ''
        };
        console.log(error);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(AnimateText, {
        text: __props.item.openAnimate ? '' : info.value.tips,
        ref_key: "AnimateTextRef",
        ref: AnimateTextRef,
        onEnd: handleEnd
      }, null, 8, ["text"])]), show.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
        class: "truncate mr-2 max-w-[200px]",
        title: info.value.reportName
      }, _toDisplayString(info.value.reportName), 9, _hoisted_5), _createVNode(_component_el_button, {
        type: "text",
        onClick: downloadPDF,
        loading: loading.value
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createElementVNode("span", {
          class: "text-xs"
        }, "下载报告", -1)]))]),
        _: 1
      }, 8, ["loading"])]), _createElementVNode("div", {
        ref_key: "contentRef",
        ref: contentRef,
        class: "pdf-content overflow-hidden"
      }, [_createVNode(ContentBlock, {
        content: handleMdHtml(info.value.attachmentDetail.fileContent || ''),
        isMd: false,
        cusSty: 1,
        height: "100%",
        onAnimateEnd: handleAnimateEnd
      }, null, 8, ["content"])], 512), !hideBtn.value ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "enlarge-reading",
        onClick: handleEditView
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode(" 全屏查看/预览 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
});